import styled from 'styled-components';

export const FeedCommentList = styled.li`
    display: flex;
    padding: calc(100vw * (10 / 375)) 0 calc(100vw * (10 / 375)) 0;
`;

export const UserImageBlock = styled.div`
    width: calc(100vw * (28 / 375));
    height: calc(100vw * (28 / 375));
    border-radius: 50%;
    overflow: hidden;
    border: solid calc(100vw * (1 / 375)) #c6c6c6;
`;

export const UserImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const CommentInfoArea = styled.div`
    width: 100%;
    margin-left: calc(100vw * (10 / 375));
`;

export const UserName = styled.span`
    font-size: calc(100vw * (14 / 375));
    font-weight: 500;
    color: #1d1d1d;
    margin-right: calc(100vw * (5 / 375));
`;

export const CommentText = styled.span`
    font-size: calc(100vw * (14 / 375));
    color: #1d1d1d;
    white-space: pre-wrap;
    word-break: break-all; 
`;

export const CommentBottomBlock = styled.div`
    display: flex;
`;

export const CommentTime = styled.p`
    font-size: calc(100vw * (11 / 375));
    line-height: 1.55;
    color: #989898;
`;

export const ReplyButton = styled.button`
    font-size: calc(100vw * (12 / 375));
    line-height: 1.55;
    color: #989898;
    margin-left: calc(100vw * (15 / 375));
`;

export const ReplyCountBlock = styled.div`
    margin-top: calc(100vh * (10 / 812));
`;

export const ReplyCount = styled.span`
    font-size: calc(100vw * (12 / 375));
    color: #989898;
`;